import React, { useCallback, useState } from 'react';
import Timer from '../timer/Timer';
import IconButton from '@mui/material/IconButton';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import ReplayIcon from '@mui/icons-material/Replay';
import '../../../styles/components/PracticeMode.css';
import HomeButton from '../navigation/HomeButton';

const BasePracticeMode = ({
  mode,
  title,
  algorithmId,
  isRecognitionMode = false,
  onComplete,
  onSkipCase,
  onRedoCase,
  renderContent,
  showSolution,
  onToggleSolution,
  showSolutionButton = true
}) => {
  const [latestSavedSolve, setLatestSavedSolve] = useState(null);
  const handleSolveSaved = useCallback((solve) => {
    setLatestSavedSolve(solve);
  }, []);

  return (
    <div
      className="practice-mode-container"
      data-latest-saved-event-id={latestSavedSolve ? latestSavedSolve.eventId : undefined}
    >
      <div className="header-container">
        <h1 className="page-title">{title}</h1>
        <HomeButton />
      </div>
      
      <div className="controls-container">
        {/* Delete latest solve stays omitted until issue #18. */}
        <IconButton 
          onClick={onRedoCase}
          title="Redo previous case"
          className="control-button"
        >
          <ReplayIcon />
        </IconButton>

        <IconButton
          onClick={onSkipCase}
          title="Skip to next case"
          className="control-button"
        >
          <SkipNextIcon />
        </IconButton>
      </div>
      
      <Timer
        algorithmId={algorithmId}
        mode={mode}
        isRecognitionMode={isRecognitionMode}
        onComplete={onComplete}
        onSolveSaved={handleSolveSaved}
      >
        {renderContent()}
        {showSolutionButton && (
          <button 
            className="hint-button"
            onClick={onToggleSolution}
          >
            {showSolution ? 'Hide Solution' : 'Show Solution'}
          </button>
        )}
      </Timer>
    </div>
  );
};

export default BasePracticeMode; 